function updateTargetVisibilityFor(checkbox) {
    let targetId = checkbox.getAttribute('data-expand-target');
    let target = document.getElementById(targetId);

    if (checkbox.checked) {
        target.classList.remove('expanding-checkbox--hidden');
    } else {
        target.classList.add('expanding-checkbox--hidden');
    }

}

function focusOnInputFor(checkbox) {
    let inputId = checkbox.getAttribute('data-expand-focus');
    if (inputId) {
        let input = document.getElementById(inputId);
        input.focus();
    }
}

module.exports = {
    initialize: function () {
        let elements = document.querySelectorAll('.checkbox-expanding');
        for (let checkbox of Array.from(elements)) {
            updateTargetVisibilityFor(checkbox);
            checkbox.addEventListener('click', e => {
                updateTargetVisibilityFor(e.currentTarget);
                focusOnInputFor(e.currentTarget);
            });
        }
    }
};
